// Chart Base Component
import React, { useRef, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';
import { resolveChartData, getItemValue, getMaxValue } from './ChartData';

const ChartBase = ({ 
  title, 
  subtitle, 
  children, 
  className = '',
  showTitle = true,
  showSubtitle = true,
  data,
  moduleId,
  actionLink = null,
  actionLinkText = 'Explore',
  ...props 
}) => {
  const { getModuleData } = useTheme();
  const svgRef = useRef(null);
  const [dimensions, setDimensions] = useState({ width: 100, height: 40 });
  
  // Get the entire module data array
  const moduleData = getModuleData(moduleId);
  const chartArray = resolveChartData(data, moduleData);
  const maxValue = getMaxValue(chartArray);


  // Handle resize events
  useEffect(() => {
    const handleResize = () => {
      if (svgRef.current) {
        const rect = svgRef.current.getBoundingClientRect();
        setDimensions({ width: rect.width, height: rect.height });
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className={`chart-base w-full theme-bg rounded-lg shadow-md p-6 ${className}`}>
      {showTitle || showSubtitle ? <div className="chart-heading flex justify-between items-start">
        <div className="flex-1">
          {/* Chart Title */}
          {showTitle && title && (
            <h3 className="chart-title">
              {title}
            </h3>
          )}
          
          {/* Chart Subtitle */}
          {showSubtitle && subtitle && (
            <p className="chart-subtitle">
              {subtitle}
            </p>
          )}
        </div>
        
        {/* Action Link */}
        {actionLink && (
          <Link 
            to={actionLink}
            className="ml-4 px-3 py-1 text-sm font-medium theme-accent hover:underline rounded border theme-border"
          >
            {actionLinkText}
          </Link>
        )}
      </div> : null}
     
      
      {/* Chart Content */}
      <div className="chart-content">
        {typeof children === 'function' ? children({ chartArray, maxValue, dimensions, svgRef }) : children}
      </div>
    </div>
  );
};

export default ChartBase;
